import React, { useEffect, useState, useCallback } from 'react';
// import { Row, Col, Upload, Button, message, Select, DatePicker } from "antd";
import IdentityForm from '../../form/subscription/IdentityForm';
import { getUser } from '../../api';
import useApplicationSession from '../../session/UserSession';

const Identification = () => {
    const [userdata, setUserdata] = useState(null);
    const token = useApplicationSession();
    const getUserInfo = useCallback(() => {
        if (token) {
            getUser({ token })
                .then((response) => {
                    const { identity } = response.data;
                    setUserdata(identity);
                })
                .catch((error) => {});
        }
    }, [token]);

    useEffect(() => {
        getUserInfo();
    }, [getUserInfo]);

    return (
        <div test_id="subscription-identification" className="subscriptionContentContainer">
            <IdentityForm value={userdata} />
        </div>
    );
};

export default Identification;
